import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

export const firebase = initializeApp(app.firebaseConfig());
export const analytics = getAnalytics(firebase);

export default firebase;
